import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from "@angular/core";
import {Constants} from "@app/constants/constants";
import {NotificationService} from "@app/services/notification.service";
import {MethodsHelper} from "@app/helpers/methods.helper";
import {Branch} from "@app/models/branch";
import {BranchService} from "@app/services/branch.service";
import {Collateral} from "@app/models/collateral";
import {AuthenticationService} from "@app/services/authentication.service";
import {CollateralAgreementDisbursement} from "@app/models/collateral-agreement-disbursement";
import {CollateralsService} from "@app/services/collaterals.service";
import {DatePipe} from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-collateral-disbursement-popup',
    templateUrl: './collateral-disbursement-popup.component.html',
    styleUrls: ['./collateral-disbursement-popup.component.css'],
    standalone: false
})

export class CollateralDisbursementPopupComponent implements OnInit, OnChanges {

    @Input() displayDialog: boolean;
    @Input() collateralAgreement: Collateral;
    @Output() onSubmit = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() disbursementReload = new EventEmitter();

    @ViewChild('form') form: any;

    collateralDisbursement: CollateralAgreementDisbursement;

    submittedForm: boolean = false;

    validationMessages: object;

    pageIndex = 0;
    pageSize = Constants.PAGE_ITEM_COUNT;
    totalElements: number;

    defaultPageParams = {
        size: 10,
        page: 0
    }

    yearRange: string;

    branchCodeList: Array<Branch>;


    constructor(
        private notificationService: NotificationService,
        private branchService: BranchService,
        private authenticationService: AuthenticationService,
        private collateralsService: CollateralsService,
        private datePipe: DatePipe,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        if (!this.collateralDisbursement) {
            this.collateralDisbursement = new CollateralAgreementDisbursement();
            this.collateralDisbursement.documentNumber = MethodsHelper.randomString(10);
            this.collateralDisbursement.collateralAgreementNumber = this.collateralAgreement.collateralAgreementNumber;
            this.collateralDisbursement.date = this.datePipe.transform(localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date(), 'dd-MM-yyyy');
            this.collateralDisbursement.amount = this.collateralAgreement.amount;
            this.collateralDisbursement.quantity = this.collateralAgreement.quantity;
            this.collateralDisbursement.channelCode = Constants.CHANNEL.CHANNEL_CODE;
            this.collateralDisbursement.currency = this.collateralAgreement.currency;
            this.collateralDisbursement.description = this.collateralAgreement.description;
            this.collateralDisbursement.initiatedUserId = this.authenticationService.getCurrentUserId();
            this.collateralDisbursement.branchId = this.collateralAgreement.branchId;
            this.collateralDisbursement.customerSpecificOptions = this.collateralAgreement.customerSpecificOptions;
            this.collateralDisbursement.purpose = this.collateralAgreement.collateralAgreementNumber + ' ' + 'Collateral disbursement';
        }
        this.validationMessages = new Object();
        this.yearRange = MethodsHelper.getYearRange(0);
        this.getBranches();
    }

    ngOnChanges() {
        this.getDisbursementInfo();
    }

    getDisbursementInfo() {
        this.collateralsService.getDisbursementInfo(this.collateralAgreement.id).subscribe({
            next: (data) => {
                this.collateralDisbursement.documentNumber = data.documentNumber;
                this.collateralDisbursement.collateralAgreementNumber = data.collateralAgreementNumber;
                this.collateralDisbursement.date = data.date;
                this.collateralDisbursement.amount = data.amount;
                this.collateralDisbursement.quantity = data.quantity;
                this.collateralDisbursement.currency = data.currency;
                this.collateralDisbursement.branchId = data.branchId;
                this.collateralDisbursement.purpose = data.purpose;
            },
            error: (err) => {
                let msg = MethodsHelper.showErrorMessageStyling(err);
                this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${msg}` + "</p></div>",
                    "");
            }
        });
    }

    getBranches() {
        const pageOption = {
            size: 10000,
            page: 0
        }
        const pageParams = { ...this.defaultPageParams, ...pageOption };
        this.branchService.getList(pageParams).subscribe(data => {
            this.branchCodeList = data.content;
            this.branchCodeList.forEach(code => {
                this.collateralDisbursement.branchId = JSON.parse(this.authenticationService.getUserRoles())[0]?.userBranchId;
            })
        });
    }

    onSave() {
        this.submittedForm = true;
        if (this.validateForm()) {
            let submittingData = this.collateralDisbursement;
            this.collateralsService.disburse(this.collateralAgreement.id, submittingData).subscribe({
                next: (data) => {
                    this.notificationService.showSuccessMessage("Successfully disbursed.", "");
                    this.cancel();
                    this.disbursementReload.emit();
                },
                error: (err) => {
                    let msg = MethodsHelper.showErrorMessageStyling(err);
                    this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${msg}` + "</p></div>",
                        "");
                }
            });

        } else {
            this.notificationService.showErrorMessage(this.translate.instant('error.something_incorrect'));
             }
    }

    validateForm() {
        for (let key in this.validationMessages) {
            if (this.validationMessages[key]) {
                return false;
            }
        }
        if (this.form.form) {
            return this.form.form.valid
        }
        return false;
    }

    cancel() {
        this.onCancel.emit();
    }

    changeBranch(value) {
        if (this.branchCodeList) {
            for (const element of this.branchCodeList) {
                if (element.id == value) {
                    this.collateralDisbursement.branchId = element.id;
                    break;
                }
            }
        }
    }

    onAmountFocusOut(event) {
        this.collateralDisbursement.amount = MethodsHelper.amountFieldFocusOut(event);
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        return !(charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    }

}
